

















































import { Component, Vue, Prop } from "vue-property-decorator";
import SalesReportChart from "../components/SalesReportChart.vue";
import {
  getSalesReport,
  GetSalesReportQuery
} from "../../api/sales-report-api";
import { addMonths, format } from "date-fns";
import SalesReportSales from "../components/SalesReportSales.vue";
import SalesReportPresentationModel from "../presenters/sales-report-presentation-model";
import SalesReportDate from "../components/SalesReportDate.vue";
import SalesReportTable from "../components/SalesReportTable.vue";
import SearchSalesReportBar from "../components/SearchSalesReportBar.vue";
import PrintSalesReport from "../components/PrintSalesReport.vue";
import VPrintButton from "@/components/VPrintButton.vue";
import { GetSalesReportQueryDetails } from "../components/SalesReportQuery.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import SalesSummary from "../components/SalesSummary.vue";

@Component({
  components: {
    VToolbar,
    SalesSummary,
    SalesReportChart,
    SalesReportTable,
    SalesReportDate,
    SalesReportSales,
    SearchSalesReportBar,
    PrintSalesReport,
    VPrintButton
  }
})
export default class SalesReportPage extends Vue {
  @Prop() projectId?: string;
  report = new SalesReportPresentationModel();
  chart = {
    labels: [] as string[],
    data: [] as number[],
    purchaseLabels: [] as string[],
    purchaseData: [] as number[],
    profitabilityData: [] as number[]
  };

  searchOptions: GetSalesReportQuery = {
    month: "",
    monthOptions: "",
    companyId: "",
    companyType: "",
    staffId: "",
    vendorId: ""
  };
  queryDetails: GetSalesReportQueryDetails = {
    companyName: "",
    companyTypeName: "",
    staffName: "",
    vendorName: "",
    periodName: ""
  };

  get projectName(): string | undefined {
    const p = this.$store.state.project;
    return p ? p.name : undefined;
  }

  get thisMonth(): string {
    return format(this.month, "yyyy 年 MM 月");
  }

  moveMonth(months: number) {
    this.month = addMonths(this.month, months);
    this.generate();
  }

  search() {
    this.generate();
  }

  protected created() {
    this.generate();
  }

  private month = new Date();

  async generate() {
    const report = await getSalesReport({
      ...this.searchOptions,
      month: format(this.month, "yyyy-MM"),
      projectId: this.projectId
    });
    const labels = report.monthlySales.map(s => s.month);
    const data = report.monthlySales.map(s => s.sales);
    const purchaseLabels = report.monthlySales.map(s => s.month);
    const purchaseData = report.monthlyPurchases.map(s => s.amounts);
    const profitabilityData = report.monthlyPurchases.map(s => s.profitability);
    this.chart = {
      labels,
      data,
      purchaseLabels,
      purchaseData,
      profitabilityData
    };
    this.report = new SalesReportPresentationModel(report);
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  print(): void {
    (this.$refs.printComponent as PrintSalesReport).print();
  }
}
